import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const ProtectedRoute = ({ children, adminOnly = false, erpOnly = false, superAdminOnly = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const { slug } = useParams();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0f0f23]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-emerald-500"></div>
      </div>
    );
  }

  if (!user || user === false) {
    // New pattern: /{slug}/login
    if (slug) {
      return <Navigate to={`/${slug}/login`} replace />;
    }
    // SuperAdmin
    if (location.pathname.startsWith('/superadmin')) {
      return <Navigate to="/superadmin/login" replace />;
    }
    return <Navigate to="/login" replace />;
  }

  if (superAdminOnly && user.role !== 'superadmin') {
    return <Navigate to="/" replace />;
  }

  if (adminOnly && user.role !== 'admin' && user.role !== 'superadmin') {
    return <Navigate to={slug ? `/${slug}/dashboard` : '/'} replace />;
  }

  if (erpOnly && !['admin', 'superadmin', 'operator', 'viewer'].includes(user.role)) {
    return <Navigate to={slug ? `/${slug}/catalogo` : '/'} replace />;
  }

  return children;
};
